import Layout from '../../components/layout/Layout'
import { ASSETS } from '@/constants/assets'
import TransparentCard from '@/components/ui/transparent-card'
import AnimatedChartExample from '@/components/ui/animated-chart-example'

const Cards = () => {
  const cards = [
    {
      title: "Womb",
      subtitle: "Simple solutions slices for complex problems. High Quality Knowledge in its <b>shortest form</b>"
    },
    {
      title: "Ahriman's Arrow",
      externalLink: "https://en.wikipedia.org/wiki/Ahriman",
      image: {
        src: ASSETS.images.geometricArrow,
        alt: "Geometric arrow design"
      }
    },
    {
      title: "Animated Metrics",
      customComponent: <AnimatedChartExample />
    }
  ]

  const emptyCards = [
    { title: "Card 1" },
    { title: "Card 2" },
    { title: "Card 3" }
  ]

  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
          Cards: A Visual Language System
        </h1>
        
        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Card Examples
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
            {cards.map((card, index) => (
              <TransparentCard
                key={index}
                {...card}
                className="aspect-[17/20] w-full"
              />
            ))}
          </div>
        </div>

        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Empty Cards
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
            {emptyCards.map((card, index) => (
              <TransparentCard
                key={index}
                {...card}
                className="aspect-[17/20] w-full"
              />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Cards 